module.exports = {
  BatchImportOrders: 'Пакетный импорт заказов',
  BatchExportOrders: 'Пакетный экспорт заказов',
  BatchExportBills: 'Пакетный экспорт счетов',
  BusinessDate: 'Дата операции',
  OperationDate: 'Дата выполнения',
  BillCreationDate: 'Дата создания счета',
  BillInvoicingDate: 'Дата выставления счета',
  BillReceivingDate: 'Дата получения счета',
  BillVoucherGenerationDate: 'Дата формирования документа по счету',
  BillNo: 'Номер счета',
  BusinessStatus: 'Статус операции',
  BusinessType: 'Тип операции',
  OperatingBranch: 'Филиал выполнения',
  ExportSettings: 'Настройки экспорта',
  AccountsReceivableBills: 'Счет к получению',
  AccountsPayableBills: 'Счет к оплате',
  ExportConditions: 'Условия экспорта',
  ReminderExportedAtOnce1000: 'Внимание: количество строк за один экспорт не должно превышать 1000',
  ConfirmExport: 'Подтвердить экспорт',
  ExportSuccessful: 'Экспорт успешно завершен',
  BusinessCreationDate: 'Дата создания операции',
  Operation: 'Действие',
  BusinessNumber: 'Номер операции',
  DirectOrder: 'Прямой заказ',
  MasterBillNumber: 'Основной номер',
  MasterBillSerialNumber: 'Серийный номер основного документа',
  OceanFreight: 'Морская перевозка',
  OceanExport: 'Морской экспорт',
  OceanImportdirectOrder: 'Морской импорт (прямой)',
  AirFreight: 'Авиаперевозка',
  AirExport: 'Авиаэкспорт',
  AirImportdirectOrder: 'Авиаимпорт (прямой)',
  All: 'Все',
  Yes: 'Да',
  No: 'Нет',
  DownloadExportResults: 'Скачать результаты экспорта',
  EnterAirImport: 'Перейти к авиаимпорту',
  EnterAirExport: 'Перейти к авиаэкспорту',
  EnterOceanImport: 'Перейти к морскому импорту',
  EnterOceanExport: 'Перейти к морскому экспорту',
  DownloadCompleted: 'Загрузка завершена',
  Return: 'Назад',
  File: 'Файл',
  ImportSettings: 'Настройки импорта',
  OceanImport: 'Морской импорт',
  AirCargoImport: 'Авиаимпорт',
  ImportFile: 'Импорт файла',
  SelectFile: 'Выбрать файл',
  DownloadTemplate: 'Скачать шаблон',
  ReminderCannotExceed100Lines: 'Внимание: количество строк за один импорт не должно превышать 100',
  ConfirmImport: 'Подтвердить импорт',
  AirCargoImportTemplate: 'Шаблон импорта авиационных грузов',
  UploadedInXLSOrFormat: 'Загружаемый файл должен быть в формате XLS или XLSX!',
  DownloadImportResult: 'Скачать результаты импорта',
  DownloadComplete: 'Загрузка завершена',
  EnterAirCargoImport: 'Перейти к авиационному импорту',
  EnterSeaCargoImport: 'Перейти к морскому импорту',
  TotalRecordsMeetTheConditions: 'Всего {0} записей соответствуют условиям экспорта',
  N0TheConditionsAndExported: '{0} записей не соответствуют условиям и не будут экспортированы',
  Success0entriesFailure0entries: 'Успешно: {0}, неудачно: {1}.'
}
